<template>
  <div class="login-container" :class="{ 'wxwork-mobile': isWxWorkMobile }">
    <el-card class="login-card">
      <!-- 企业微信LOGO + 标题 -->
      <div class="login-header">
        <h2 class="login-title">任务管理系统 - 企业微信登录</h2>
      </div>
      <el-form
        ref="loginForm"
        :model="loginForm"
        :rules="loginRules"
        label-width="80px"
        class="login-form"
      >
        <el-form-item label="账号" prop="username">
          <el-input v-model="loginForm.username" placeholder="请输入管理员账号"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input
            v-model="loginForm.password"
            type="password"
            placeholder="请输入管理员密码"
            @keyup.enter.native="handleLogin"
          ></el-input>
        </el-form-item>
        <el-form-item label-width="0px" class="login-btn-group">
          <el-button type="primary" @click="handleLogin" class="login-btn">账号密码登录</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
        <!-- 企业微信登录按钮 -->
        <el-form-item label-width="0px" class="wechat-work-login-group">
          <el-button type="success" icon="el-icon-wechat" @click="handleWechatWorkAuth" class="wxwork-login-btn">
            企业微信授权登录
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { login } from '@/api/user';
import { isWxWorkEnv } from '@/utils/request';

export default {
  name: 'Login',
  data() {
    return {
      loginForm: {
        username: '',
        password: ''
      },
      loginRules: {
        username: [
          { required: true, message: '请输入账号', trigger: 'blur' },
          { min: 1, max: 20, message: '账号长度在 1 到 20 个字符', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 20, message: '密码长度在 6 到 20 个字符', trigger: 'blur' }
        ]
      },
      wechatWorkConfig: {
        corpId: 'wwd88f80a88308bf49',
        redirectUri: encodeURIComponent('https://gslhys.com/wechat/work/callback'),
        responseType: 'code',
        agentId: '1000018',
        scope: 'snsapi_base'
      },
      isWxWorkMobile: false
    };
  },
  created() {
    // 初始化企微移动端判断，避免undefined报错
    this.isWxWorkMobile = isWxWorkEnv() && /mobile/i.test(navigator.userAgent) || false;
  },
  methods: {
    // 账号密码登录：存储登录类型，适配首页菜单逻辑
    async handleLogin() {
      // 避免表单未挂载导致的$refs报错
      if (!this.$refs.loginForm) return;
      
      this.$refs.loginForm.validate(async (valid) => {
        if (!valid) return;

        try {
          const res = await login({
            username: this.loginForm.username,
            password: this.loginForm.password
          });

          // 存储核心鉴权信息
          localStorage.setItem('accessToken', res.token || '');
          localStorage.setItem('adminName', res.username || this.loginForm.username);
          // 关键：存储登录类型 - 普通账号密码登录
          localStorage.setItem('loginType', 'normal');

          // 优化跳转：普通登录默认到导入页，避免跳转到隐藏的任务列表
          const redirect = this.$route.query.redirect || '/excel/import';
          this.$router.push(redirect);
          this.$message.success('登录成功，欢迎 ' + (res.username || this.loginForm.username) + '！');
        } catch (error) {
          this.$message.error(error.response?.data?.msg || '登录失败，请检查账号密码');
          console.error('登录失败：', error);
        }
      });
    },
    // 重置表单：增加容错，避免表单未挂载报错
    resetForm() {
      if (this.$refs.loginForm) {
        this.$refs.loginForm.resetFields();
      }
    },
    // 企微授权登录：修复模板字符串，用字符串拼接避免ESLint报错
    handleWechatWorkAuth() {
      const { corpId, redirectUri, responseType, scope, agentId } = this.wechatWorkConfig;
      const pageRedirect = this.$route.query.redirect || '/tasks';
      // 修复：state用字符串拼接，避免模板字符串解析报错，仅传递跳转地址（简化逻辑，避免JSON解析报错）
      const state = encodeURIComponent(pageRedirect);
      // 核心修复：模板字符串改为字符串拼接，彻底解决ESLint解析错误
      const wechatWorkAuthUrl = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + corpId + '&redirect_uri=' + redirectUri + '&response_type=' + responseType + '&scope=' + scope + '&agentid=' + agentId + '&state=' + state + '#wechat_redirect';
      
      try {
        window.location.href = wechatWorkAuthUrl;
      } catch (e) {
        const a = document.createElement('a');
        a.href = wechatWorkAuthUrl;
        a.target = '_self';
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
    }
  }
};
</script>

<style scoped>
/* 基础登录容器 */
.login-container {
  width: 100%;
  height: 100vh;
  background: #f5f7fa;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
  padding: 0;
}
/* 企业微信移动端适配 */
.wxwork-mobile.login-container {
  background: #fff;
  padding: 10px;
  align-items: flex-start;
  padding-top: 20px;
}

.login-card {
  width: 420px;
  box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  border: none;
  padding: 24px;
}
/* 移动端卡片宽度自适应 */
.wxwork-mobile .login-card {
  width: 100%;
  box-shadow: none;
  border: 1px solid #e5e6eb;
}

/* 标题样式 */
.login-header {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
}
.login-title {
  text-align: center;
  color: #2e3b4e;
  font-weight: 600;
  font-size: 18px;
  margin: 0;
}

.login-form {
  margin-top: 16px;
}
.login-btn-group {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}
.login-btn {
  width: 120px;
  margin-right: 20px;
}

/* 企微登录按钮样式 */
.wechat-work-login-group {
  display: flex;
  justify-content: center;
}
.wxwork-login-btn {
  width: 180px;
  height: 40px;
  font-size: 15px;
  background-color: #2e3b4e;
  border-color: #2e3b4e;
}
.wxwork-login-btn:hover {
  background-color: #3a495e;
  border-color: #3a495e;
}

/* 媒体查询：适配手机屏幕 */
@media (max-width: 768px) {
  .login-title {
    font-size: 16px;
  }
  .wxwork-login-btn {
    width: 100%;
  }
  .login-card {
    padding: 16px;
  }
}
</style>